import { openDeeplink } from '../actions/timePanelStoreActions';
import { getSelectedCalendarItemId } from '../selectors/timePanelStoreSelectors';
import { observer } from 'mobx-react-lite';
import { IButtonProps, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ClientItemId } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { addPopoutV2 } from 'owa-popout-v2';
import { getCurrentPanelView } from 'owa-time-panel-view-stack';
import { getCalendarPath, getTodoModuleUrl } from 'owa-url';
import * as React from 'react';
import {
    openCalendarTitleText,
    openCalendarEventDetailsText,
    openTasksTitleText,
    openComposeInNewWindow,
} from './TimePanelHeaderButtonWell.locstring.json';
import { popOutComposeForm } from 'owa-time-panel-compose';

const styles = require('./TimePanelHeaderButtonWell.scss');

export default observer(function TimePanelHeaderButtonWell() {
    const panelView = getCurrentPanelView();

    const itemId = getSelectedCalendarItemId();

    const onClickCalendarEventDetailsDeeplinkCallback = React.useCallback(() => {
        if (itemId) {
            onClickCalendarEventDetailsDeeplink(itemId);
        }
    }, [itemId]);

    let deeplinkButtonProps: IButtonProps;
    switch (panelView) {
        case 'Calendar':
        case 'Conflicts':
            deeplinkButtonProps = {
                title: loc(openCalendarTitleText),
                href: getCalendarPath(),
                onClick: onClickCalendarModuleDeeplink,
            };
            break;
        case 'EventDetails':
        case 'AttendeeTracking':
            deeplinkButtonProps = itemId
                ? {
                      title: loc(openCalendarEventDetailsText),
                      onClick: onClickCalendarEventDetailsDeeplinkCallback,
                  }
                : undefined;
            break;
        case 'Tasks':
            deeplinkButtonProps = {
                title: loc(openTasksTitleText),
                href: getTodoModuleUrl(),
                onClick: onClickTasksModuleDeeplink,
            };
            break;
        case 'ComposeForm':
            deeplinkButtonProps = {
                title: loc(openComposeInNewWindow),
                onClick: onClickCalendarComposeForm,
            };
            break;
        default:
            deeplinkButtonProps = undefined;
    }

    return (
        <div className={styles.buttonWellContainer}>
            {deeplinkButtonProps && (
                <IconButton
                    {...deeplinkButtonProps}
                    iconProps={{ iconName: ControlIcons.MiniExpandMirrored }}
                    target={'_blank'}
                    styles={{
                        root: styles.deeplinkButton,
                    }}
                />
            )}
        </div>
    );
});

function onClickCalendarModuleDeeplink(): void {
    openDeeplink('CalendarModule');
}

function onClickCalendarEventDetailsDeeplink(itemId: ClientItemId): void {
    openDeeplink('CalendarEventDetails');

    const CALENDAR_POPOUT_OPTIONS = {
        width: 1095,
        height: 640,
    };

    addPopoutV2(
        'calendar',
        `read/${encodeURIComponent(itemId.Id)}`,
        { entrySource: 'TimePanelPeek' },
        CALENDAR_POPOUT_OPTIONS,
        false /* skipOptinCheck */
    );
}

function onClickTasksModuleDeeplink(): void {
    openDeeplink('TasksModule');
}

function onClickCalendarComposeForm(): void {
    openDeeplink('ComposeForm');
    popOutComposeForm();
}
